function Spinner({ size = 24, color = "#1c3259" }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        border: `3px solid #e2e8f0`,
        borderTopColor: color,
        borderRadius: "50%",
        animation: "spin 0.7s linear infinite",
      }}
    />
  );
}

export default Spinner;
